import React from 'react';
import PropTypes from "prop-types";
import GenericLabel from '../GenericLabel'
import { formatClassName } from '../../Util';

export default class CardSpecialLabel extends GenericLabel {
  static propTypes = {
    label: PropTypes.string,
    icon: PropTypes.string,
    iconColor: PropTypes.oneOf(['gray', 'red', 'branded', 'green']),
    fontFamily: PropTypes.string,
    fontWeight: PropTypes.oneOf(['normal', 'bold']),
    hasMedia: PropTypes.bool,
    type: PropTypes.string
  };

  static defaultProps = {
    fontFamily: 'zmdi',
    iconColor: 'gray',
    fontWeight: 'normal'
  }

  getSpecialLabelClasses = () => {
    const { type, hasMedia } = this.props;
    return formatClassName([
      `card-special-label`,
      `card-special-label-${type}`,
      { 'no-media': !hasMedia }
    ]);
  }

  render() {
    let specialLabelClasses = this.getSpecialLabelClasses();
    return (
      <div className={specialLabelClasses}>
        <GenericLabel {...this.props} />
      </div>
    )
  }
}
